import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-5 text-center">
          * * *
        </p>

        <p class="poem-block mb-3">
          Как лист увядший падает на душу,<br/>
          И холодит осенняя листва,<br/>
          Так падают бессильные слова,<br/>
          Скользя, не задевая наши уши.
        </p>
          
        <p class="poem-block mb-3">
          Поднятый в воздух прах чужих могил,<br/>
          Зачем ты носишься среди живых, незваный?<br/>
          Ты в мир людей, причудливый и странный<br/>
          Тупую геометрию вселил.
        </p>
        
        <p class="poem-block mb-3">
          Мертвеют души, бьется метроном,<br/>
          И опускаются бессильно руки<br/>
          В плену у бесконечной синей скуки,
        </p>
        
        <p class="poem-block mb-3">
          Рожденной мертвой мыслью без опоры.<br/>
          Когда закончатся пустые споры?<br/>
          А жизнь сияет солнцем за окном.
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Как лист увядший падает на душу'
}
const itemDate = {
  rus: '15 августа 2004 г.'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;